import JQueryView, { on } from '../../../../../common/views/jqueryView';

export default class FormView extends JQueryView {
  unit: number;
  price: number;

  constructor(unit: number, price: number) {
    super('.simple_form');
    this.unit = unit;
    this.price = price;
    this.render();
  }

  @on({ event: 'keyup', selector: '#stock_unit_amount' })
  onKeyupStockUnitAmount() {
    this.render();
  }

  @on({ event: 'change', selector: '#stock_unit_amount' })
  onChangeStockUnitAmount() {
    this.render();
  }

  render() {
    const amount =
      parseInt($('#stock_unit_amount').val()?.toString() || '') * this.unit;
    $('#stock_amount').html(amount.toString());
    $('#payment').html((amount * this.price).toString());
    $('#company_stock_transfer_amount').val(amount);
  }
}
